<!--ProductIntro:产品介绍 2021/12/22 14:45:01 YuAng-->

<template>
  <div class="ho-product-intro">
    <p class="ho-part-title">产品介绍</p>
    <van-tabs type="card" color="#28ABFF" @change="changeTab">
      <van-tab v-for="(item,index) in tabs" :key="'tabs' + index" :name="'tab' + item.id" :title="item.mainTitle"></van-tab>
    </van-tabs>
    <van-swipe indicator-color="#70A6FE" @change="swipeChange">
      <van-swipe-item v-for="(item, index) in selectedTab.children" :key="'loop' + item.id" :loop="false">
        <div class="ho-loop-div" :class="item.device">
          <p style="text-align: center">{{item.title}}</p>
          <p style="font-size: 12px">{{item.desc}}</p>
          <el-carousel :ref="'carousel' + selectedTab.id + '' + index" height="250px" indicator-position="none" arrow="never">
            <el-carousel-item v-for="index in item.imgCount" :key="'child' + item.id + 'x' + index">
              <div class="ho-child-div">
                <img :src="require('../../../../assets/images/' + imgPrefix + selectedTab.id + '' + item.id  + '' + index + '.png')" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
export default {
  name: 'ProductIntro',
  props: {
    imgPrefix: {
      type: String,
      default: 'school/area-part3-'
    },
    tabs: {
      type: Array,
      default: function () {
        return [
          {
            id: 1,
            mainTitle: '数字资源',
            children: [
              {
                id: 1,
                title: '优质教学资源',
                desc: '覆盖全学段、全学科、全教材版本、全类型，满足多种教学需求。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 2,
                title: '精品自学资源',
                desc: '精选同步巩固资源、专项突破内容，分层靶向提升。',
                imgCount: 1,
                device: 'pad'
              },
              {
                id: 3,
                title: '特色学科资源',
                desc: '英语学科特色专题内容，听说读写系统训练，口语、作文智能测评。',
                imgCount: 2,
                device: 'pc'
              }
            ]
          },
          {
            id: 2,
            mainTitle: '智慧教学',
            children: [
              {
                id: 1,
                title: '轻松备课',
                desc: '资源智能推荐、文件在线编辑、集体协同备课，让备课更轻松、更高效。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 2,
                title: '高效授课',
                desc: '师生互动，随堂检测，即时反馈，打造多元趣味课堂。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 3,
                title: '课后训练',
                desc: '科学分层布置，支持自动批改，精准学情分析，灵活高效讲评。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 4,
                title: '智能考评',
                desc: '智能题库采用“AI算法+老师助力+专家诊断”，输出教师讲评、学生个性化考试报告。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 5,
                title: '学情诊断',
                desc: '基于全流程数据分析，生成个性化辅导方案，助力精准教学、靶向提升。',
                imgCount: 1,
                device: 'pc'
              }
            ]
          },
          {
            id: 3,
            mainTitle: '智慧研训',
            children: [
              {
                id: 1,
                title: '智慧研训',
                desc: '提供教师专业培训与研修服务，助力教师基本技能提升与职业发展，帮助教师上好每一堂课。',
                imgCount: 2,
                device: 'pc'
              }
            ]
          },
          {
            id: 4,
            mainTitle: '智慧学习',
            children: [
              {
                id: 1,
                title: '智慧学习',
                desc: '提供丰富学生自学资源，教材同步、专项突破，助力学生个性化学习，巩固课堂学习成果。',
                imgCount: 2,
                device: 'pad'
              }
            ]
          },
          {
            id: 5,
            mainTitle: '智慧管理',
            children: [
              {
                id: 1,
                title: '精准学情',
                desc: '多维度学情数据全面记录、客观分析，辅助教学策略调整。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 2,
                title: '教学评价',
                desc: '多维度学生评价体系，助力推进学风、德育、校风建设。',
                imgCount: 1,
                device: 'pc'
              },
              {
                id: 3,
                title: '科学管理',
                desc: '纵览全校教学动态，多维度分析，教学评比有据可依，助力学校科学管理。',
                imgCount: 2,
                device: 'pc'
              },
              {
                id: 4,
                title: '家校互联',
                desc: '家校互通互联，实时了解孩子在校动态，促进家校共育。',
                imgCount: 1,
                device: 'app'
              }
            ]
          }
        ]
      }
    }
  },
  data() {
    return {
      selectedTab: { children: [] }
    }
  },
  created() {
    this.changeTab('tab1')
  },
  methods: {
    changeTab: function (tabName) {
      this.selectedTab = this.tabs.find(item => 'tab' + item.id === tabName)
      this.$nextTick(() => {
        this.swipeChange(0)
      })
    },
    swipeChange: function (index) {
      const key = 'carousel' + this.selectedTab.id + '' + index
      if (this.$refs[key]) {
        this.$refs[key][0].setActiveItem(0)
      }
    }
  }
}
</script>

<style scoped>
.ho-product-intro {
  background: #f3f3f3;
  padding: 8px 8px 24px 8px;
}

.ho-product-intro >>> .van-tabs__nav--card {
  margin: 0;
  border-radius: 4px;
}

.ho-product-intro >>> .van-tab {
  padding: 2px 4px;
}

.ho-loop-div {
  padding-top: 8px;
}

.ho-loop-div > p {
  padding: 0 8px 8px 8px;
}

.ho-loop-div.pc >>> .el-carousel {
  background: url(../../../../assets/images/its-pc-bg.png) no-repeat;
  background-size: 100% 250px;
}

.ho-loop-div.pad >>> .el-carousel {
  background: url(../../../../assets/images/its-pad-bg.png) no-repeat;
  background-size: 100% 250px;
}

.ho-child-div {
  height: 250px;
}

.ho-loop-div.pc .ho-child-div {
  height: 218px;
  padding: 12px 12px 32px 12px;
}

.ho-loop-div.pad .ho-child-div {
  padding: 14px 22px 16px 29px;
}

.ho-child-div img {
  width: 100%;
  height: 100%;
}

.ho-product-intro >>> .van-swipe {
  padding-bottom: 16px;
}

.ho-product-intro >>> .van-swipe__indicators {
  bottom: 0;
}

.ho-product-intro >>> .van-swipe__indicator {
  background-color: #d8d8d8;
}
</style>